// @flow

// Modules
import React from 'react';
import styled from 'styled-components';
import { findIndex } from 'lodash';

// Style
import { BLUE_GREY, getGameTypeColorFont } from 'src/styles/palettes';

// Methods
import { __ } from 'src/methods/l10n';

// Components
import OptionsBar from 'components/optionsbar';
import Dropdown from 'components/dropdown';
import DatePicker from 'components/datepicker';
import Prizepool from 'components/prizepool';
import Icons from 'containers/icons';

/**
 * Styles
 */

const HeaderRoot = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5em;
  padding-bottom: 0.7em;
  margin-bottom: 1em;
  background-color: ${BLUE_GREY[900]};
  border-radius: 8px;
`;

const OptionsLines = styled.div`
  display: flex;
  height: 2.1em;
  ${(props) => props.hasMarginBot && 'margin-bottom: 1.5em;'}
  justify-content: space-between;
`;

const Dotation = styled(Prizepool)`
  margin-bottom: 0.8em;
`;

/**
 * Types
 */

type PropTypes = {
  challenges: Object,
  selectedChallenge: number,
  selectedType: number,
  selectedDate: number,
  setSelectedChallenge: (id: number) => void,
  setSelectedType: (id: number) => void,
  setSelectedDate: (id: number) => void,
  resetConf: () => void,
  navigate: (action: string) => void
};

/*
 ** Component
 */

const Header = (props: PropTypes): React$Element<any> => {
  const { challenges, selectedChallenge, selectedType, selectedDate, navigate } = props;
  const challenge = challenges && challenges[selectedChallenge] && challenges[selectedChallenge];
  const types = challenge && challenge.types;
  const selectedTypeValue = types && types[selectedType];
  const dates = selectedTypeValue && selectedTypeValue.date_range && selectedTypeValue.date_range.valid_dates;
  const dropdownLabel = selectedTypeValue ? selectedTypeValue.name : '';
  const prizepool = selectedTypeValue && selectedTypeValue.prizepool;
  let optionsTag = [];

  if (types && types.length) {
    optionsTag = types.map((data, index) => (
      <Dropdown.Item key={index} value={data.name} selected={selectedType === index} label={data.name} />
    ));
  }

  return (
    <HeaderRoot>
      <OptionsBar
        options={challenges}
        selectedOptions={selectedChallenge}
        onItemClick={props.setSelectedChallenge}
        disabled={!challenges}
      />
      {types && types.length > 1 && (
        <OptionsLines hasMarginBot>
          <Dropdown
            hideOnSelect
            label={dropdownLabel}
            selectedItems={[selectedType]}
            position="bottom-left"
            onItemClick={(selectedValue) => props.setSelectedType(findIndex(types, { name: selectedValue }))}
            disabled={!challenges || types.length === 1}>
            {optionsTag}
          </Dropdown>
        </OptionsLines>
      )}
      {prizepool && (
        <Dotation
          amount={prizepool}
          currency={'€'}
          label={__('to be shared out every day!')}
          color={getGameTypeColorFont(challenge && challenge.id)}
        />
      )}

      <OptionsLines>
        <DatePicker dates={dates} selectedDate={selectedDate} onItemClick={props.setSelectedDate} />
        <Icons size={'1.8em'} resetConf={props.resetConf} navigate={navigate} />
      </OptionsLines>
    </HeaderRoot>
  );
};

export default Header;
